import { overlay } from 'overlay-kit';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/shadcn/dialog';

interface ShowMemoModalOptions {
  memo: string;
  title?: string;
}

export function showMemoModal({ memo, title = 'Memo' }: ShowMemoModalOptions): Promise<void> {
  return overlay.openAsync(({ isOpen, close }) => (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) close();
      }}
    >
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="bg-muted mt-4 max-h-96 overflow-y-auto rounded-md p-4">
          <p className="text-sm whitespace-pre-wrap">{memo}</p>
        </div>
      </DialogContent>
    </Dialog>
  ));
}
